import React, { useEffect, useState } from 'react';

const UpdateApp = () => {
  const [status, setStatus] = useState('Starting update...');

  useEffect(() => {
    const runUpdate = async () => {
      try {
        setStatus('Stopping background sync and notifications...');
        // Attempt to stop any background sync/notifications if applicable
        // Safe no-ops if not available

        setStatus('Unregistering service workers...');
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const registration of registrations) {
            try {
              // Tell any waiting worker to activate immediately
              if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
              }
              await registration.unregister();
            } catch (err) {
              console.warn('Failed to unregister a service worker:', err);
            }
          }
        }

        setStatus('Clearing application caches...');
        if (window.caches && caches.keys) {
          const cacheNames = await caches.keys();
          await Promise.all(
            cacheNames.map((cacheName) => caches.delete(cacheName))
          );
        }

        // Also clear persisted storage where supported (best-effort)
        try {
          if (navigator.storage && navigator.storage.persisted) {
            // No direct clear API; clearing caches and reloading suffices for PWA assets
          }
        } catch {}

        setStatus('Reloading with the latest version...');

        // Small delay to ensure unregister completes
        setTimeout(() => {
          window.location.replace('/');
        }, 250);
      } catch (error) {
        console.error('Update failed:', error);
        setStatus('Update encountered an error. Reloading...');
        setTimeout(() => {
          window.location.replace('/');
        }, 500);
      }
    };

    runUpdate();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-teal-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl text-center border border-gray-100 max-w-md w-full mx-4">
        <div className="mb-6">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white animate-spin" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Updating Application</h1>
          <p className="text-gray-600">{status}</p>
        </div>
        
        {/* Progress indicator */}
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
          <div className="bg-gradient-to-r from-blue-500 to-teal-500 h-2 rounded-full transition-all duration-500 animate-pulse"></div>
        </div>
        
        <div className="text-sm text-gray-500">
          Please wait while we update your application...
        </div>
      </div>
    </div>
  );
};

export default UpdateApp;


